import { useEffect, useState } from "react";
import api from "@/lib/api";
import ProductCard from "@/components/ProductCard";
import { Search } from "lucide-react";

const CATS = ["All", "Inspirational Books", "Music Guides", "Business & Data", "Devotionals"];

export default function EbooksStore() {
  const [products, setProducts] = useState([]);
  const [category, setCategory] = useState("All");
  const [q, setQ] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const params = { type: "ebook" };
    if (category !== "All") params.category = category;
    if (q) params.q = q;
    api.get("/products", { params }).then((r) => setProducts(r.data)).finally(() => setLoading(false));
  }, [category, q]);

  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16">
      <div className="label-eyebrow mb-3">E-books</div>
      <h1 className="font-serif-display text-5xl lg:text-6xl text-white">Words that <span className="italic text-[#D4AF37]">stir the soul</span></h1>
      <p className="text-neutral-400 mt-4 max-w-2xl">Inspirational reads, devotionals, music guides and business analytics books — instant PDF downloads after purchase.</p>

      <div className="mt-10 flex flex-col lg:flex-row gap-6 lg:items-center justify-between">
        <div className="relative max-w-md w-full">
          <Search size={16} className="absolute left-4 top-1/2 -translate-y-1/2 text-neutral-500" />
          <input
            data-testid="ebook-search"
            value={q} onChange={(e) => setQ(e.target.value)}
            placeholder="Search e-books..."
            className="w-full bg-black border border-white/15 focus:border-[#D4AF37] outline-none pl-11 pr-4 py-3 rounded text-white text-sm"
          />
        </div>
        <div className="flex flex-wrap gap-2">
          {CATS.map((c) => (
            <button key={c}
              data-testid={`ecategory-${c.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              onClick={() => setCategory(c)}
              className={`px-3 py-1.5 text-xs tracking-widest uppercase rounded border transition-colors ${
                category === c ? "bg-[#D4AF37] text-black border-[#D4AF37]" : "border-white/15 text-neutral-300 hover:border-[#D4AF37]/50"
              }`}>{c}</button>
          ))}
        </div>
      </div>

      <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6" data-testid="ebooks-grid">
        {loading ? <div className="col-span-full text-neutral-500 text-sm">Loading...</div>
          : products.length === 0 ? <div className="col-span-full text-neutral-500">No e-books found.</div>
          : products.map((p) => <ProductCard key={p.id} product={p} />)}
      </div>
    </div>
  );
}
